import DateRangePicker from "@/components/DateRangePicker";
import DebouncedInput from "@/components/DebouncedInput";
import { SimpleGrid } from "@chakra-ui/react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { FiltersType } from "../types/filters.type";

type Props = {
  queryFilters: FiltersType;
  setQueryFilters: Dispatch<SetStateAction<FiltersType>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchByDocumentNumber = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({
        ...prev,
        documentNumber: value || undefined,
      })),
    [setQueryFilters]
  );

  const handleSearchByDateRange = useCallback(
    (dates: [string, string] | undefined) => {
      setQueryFilters((prev) => ({ ...prev, dateRange: dates }));
    },
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={3}>
      <DebouncedInput
        size="sm"
        placeholder="Cédula"
        _placeholder={{ color: "#5D5C60" }}
        value={queryFilters.documentNumber}
        onDebouncedChange={handleSearchByDocumentNumber}
      />
      <DateRangePicker
        maxDate={new Date()}
        placeholder="Fecha de suscripción"
        values={queryFilters.dateRange}
        setValues={handleSearchByDateRange}
      />
    </SimpleGrid>
  );
};

export default Filters;
